import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { SUMMARY_CARD_HEIGHT } from '../ActionGoals/constants'

export const EmptyActionGoal = ({ cardHeight = SUMMARY_CARD_HEIGHT }) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  useLazyScreenPreload('ActionGoalListScreen')

  const onPress = () => {
    navigation.navigate('ActionGoalListScreen')
  }

  return (
    <TouchableOpacity
      style={[styles.container, { height: cardHeight }]}
      onPress={onPress}
      accessibilityLabel="Add a new action goal"
    >
      <View style={styles.content}>
        <Icon weight="bold" name="plus" size={16} />
        <Text bold type="large">
          Add
        </Text>
      </View>
    </TouchableOpacity>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    backgroundColor: 'theme.surface.base3',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: 'theme.surface.base',
    width: '100%',
    alignItems: 'center',
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
})
